import { isEmpty } from 'lodash';
import EmptyStateIcon from 'src/assets/images/EmptyState.svg?react';
import { lang } from 'src/utils';

import type { IEmptyStateProps } from './EmptyState.interface';
import {
  EmptyStateContainer,
  IconContainer,
  MessageText,
} from './EmptyState.styled';

export const EmptyState = ({
  isLoading = false,
  dataToCheck = undefined,
  message = undefined,
  icon = undefined,
}: IEmptyStateProps) => {
  if (isLoading || !isEmpty(dataToCheck)) {
    return null;
  }

  return (
    <EmptyStateContainer>
      <IconContainer>{icon ? icon : <EmptyStateIcon />}</IconContainer>
      <MessageText>{message ? message : lang.noResultText}</MessageText>
    </EmptyStateContainer>
  );
};
